import API from "utils/API";
import authHeader from "utils/auth-header";
import { ICategory } from "../../../domain/ICategory";
import { IInput } from "../domain/IInput";
import { IInputCreate } from "../domain/IInputCreate";
import { IItem } from "../domain/IItem";
import { IResponseCategories } from "../domain/IResponseCategories";
import { IGetExemptionsResponse } from "../domain/IGetExemptionsResponse";
import { IResponseInputs } from "../domain/IResponseInputs";
import { IResponseItems } from "../domain/IResponseItems";
import { IGetInputsRequestParams } from "../domain/IGetInputsRequestParams";
import { IExemptionSearch } from "../domain/IExemptionSearch";
import { IMessage } from "domain/IMessage";
import { getQeuryParams } from "utils/queryParamsUtil";
import { IConsumablesInputUpdate } from "../domain/IConsumablesInputUpdate";
import { IConsumablesOutputUpdate } from "../domain/IConsumablesOutputUpdate";
import { IExemption } from "../domain/IExemption";
import { ResourceMaintenanceType } from "../domain/ResourceMaintenanceType";
import { IResponseResourceMaintenanceTypes } from "../domain/IResponseResourceMaintenanceTypes";
import { IRepositoryDetails } from "../domain/IRepositoryDetails";
import { IGetPageRequestParams } from "hooks/pagingAndSort";

const getAllCategoriesForItem = async (): Promise<ICategory[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResponseCategories>(
      "/consumables/public/category",
      { headers }
    );
    let categories = response.data.categories;
    return categories;
  } catch (err) {
    throw err;
  }
};

const getAllMaintenanceTypesForResources = async (): Promise<ResourceMaintenanceType[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResponseResourceMaintenanceTypes>(
      "/consumables/public/maintenance-type",
      { headers }
    );
    let maintenanceTypes = response.data.maintenanceTypes;
    return maintenanceTypes;
  } catch (err) {
    throw err;
  }
};

const getRepository = async (): Promise<IRepositoryDetails> => {
  var headers = authHeader();
  try {
    const response = await API.get<IRepositoryDetails>(
      "/consumables/public/repository",
      { headers }
    );
    let repositoryDetails = response.data;
    return repositoryDetails;
  } catch (err) {
    throw err;
  }
};


const getAllKnownInputItems = async (): Promise<IItem[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResponseItems>(
      "/consumables/public/input/item",
      { headers }
    );
    let items = response.data.items;
    return items;
  } catch (err) {
    throw err;
  }
};

const createInputItem = async (itemName: string): Promise<IItem> => {
  var headers = authHeader();
  try {
    const response = await API.post<IItem>(
      "/consumables/public/input/item",
      { itemName },
      { headers }
    );
    let item = response.data;
    return item;
  } catch (err) {
    throw err;
  }
};

const getInputs = async (
  search: IGetInputsRequestParams | undefined,
  pagingData: IGetPageRequestParams,
  signal: AbortSignal
): Promise<IResponseInputs> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResponseInputs>(
      `/consumables/public/input${getQeuryParams({ ...search, ...pagingData })}`,
      { headers, signal }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const createInput = async (data: IInputCreate): Promise<IInput> => {
  var headers = authHeader();
  try {
    const response = await API.post<IInput>("/consumables/public/input", data, {
      headers,
    });
    let item = response.data;
    return item;
  } catch (err) {
    throw err;
  }
};

const updateInput = async (
  data: IConsumablesInputUpdate
): Promise<IInput[]> => {
  var headers = authHeader();
  try {
    const { inputId, ...rest } = data;
    const response = await API.put<IResponseInputs>(
      `/consumables/public/input/${inputId}`,
      { ...rest },
      { headers }
    );
    let inputs = response.data.inputs;
    return inputs;
  } catch (err) {
    throw err;
  }
};

const deleteInput = async (inputId: number): Promise<string> => {
  var headers = authHeader();
  try {
    const response = await API.delete<IMessage>(
      `/consumables/public/input/${inputId}`,
      { headers }
    );
    return response.data.message;
  } catch (err) {
    throw err;
  }
};

const getExemptions = async (
  search: IExemptionSearch,
  pagingData: IGetPageRequestParams,
  signal: AbortSignal
): Promise<IGetExemptionsResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<IGetExemptionsResponse>(
      `/consumables/public/output-items${getQeuryParams({ ...search, ...pagingData })}`,
      { headers, signal }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const updateOutput = async (
  data: IConsumablesOutputUpdate
): Promise<IGetExemptionsResponse> => {
  var headers = authHeader();
  try {
    const { outputItemId, ...rest } = data;
    const response = await API.put<IGetExemptionsResponse>(
      `/consumables/public/output-item/${outputItemId}`,
      { ...rest },
      { headers }
    );
    let outputItems = response.data;
    return outputItems;
  } catch (err) {
    throw err;
  }
};

const getOutput = async (
  outputId: number
): Promise<IExemption> => {
  var headers = authHeader();
  try {
    const response = await API.get<IExemption>(
      `/consumables/public/output/${outputId}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const consumablesService = {
  getAllCategoriesForItem,
  getAllMaintenanceTypesForResources,
  getRepository,
  getAllKnownInputItems,
  createInputItem,
  getInputs,
  updateInput,
  createInput,
  deleteInput,
  getOutput,
  getExemptions,
  updateOutput,
};
